import ContentHeader from "@/components/ContentHeader";
import InfinityScrollList from "@/components/InfinityScrollList";
import Loading from "@/components/Loading";
import { useCopyrights, usePagination } from "@/hooks";
import styles from "@/styles/List.module.scss";
import classnames from "classnames";
import { cloneElement, createElement, memo, useEffect } from "react";

export default function List({
  header,
  itemComponent, // itemをレンダーするコンポーネント
  limit,
  maxLength,
  loadMore,
  loading, // useQueryの戻り値
  error, // useQueryの戻り値
  fetchMore, // useQueryの戻り値
  variables, // useQueryの戻り値
  items,
  noContent,
  viewTypeClassName, // このpropsなくしたい
}) {
  if (error) {
    // TODO: error view
  }

  const { setCopyrights } = useCopyrights();
  const { enableLoadMore, fetchMoreCallback } = usePagination({
    limit: limit ?? variables?.limit,
    maxLength,
    loadMore,
    fetchMore,
    items,
  });

  const dataLength = items?.data?.length || 0;
  useEffect(() => {
    if (items && items.data.length > 0) {
      const copyrights = items.data.map((item) => item.copyright);
      setCopyrights(copyrights);
    }
  }, [dataLength]);

  if (!loading && items?.data?.length === 0) {
    if (noContent) {
      return <div className={styles.container}>{cloneElement(noContent)}</div>;
    } else {
      return null;
    }
  }

  return (
    <div
      className={classnames(styles.container, {
        [styles.grid]: viewTypeClassName === "grid",
        [styles.list]: viewTypeClassName === "list",
        [styles.pickuplist]: viewTypeClassName === "pickuplist",
        [styles.channelsList]: viewTypeClassName === "channelsList",
      })}
    >
      {header && (
        <ContentHeader viewTypeClassName={viewTypeClassName} {...header} />
      )}
      {loading && dataLength === 0 && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      <div className={styles.list}>
        <InfinityScrollList
          loadMore={enableLoadMore}
          fetchMore={fetchMoreCallback}
        >
          {items &&
            items.data.map((item, i) => (
              <ListItem
                key={`list-${i}`}
                itemComponent={itemComponent}
                item={item}
              />
            ))}
        </InfinityScrollList>
      </div>
    </div>
  );
}

const ListItem = memo(({ itemComponent, item }) => {
  return (
    <div className={styles.listItem}>
      {createElement(itemComponent, { item })}
    </div>
  );
});
